import React, { useState, useEffect } from 'react';
import { Stack, TableBody, TableCell, TableRow } from '@mui/material';
import axios from 'axios';
import { convToTime } from '../../../utils/helpers';
import { AddButton } from '../../../components/common/button/CustomButtons';
import ChildHeader from '../../../components/ui/ChildHeader';
import { SearchFilterContainer } from '../../../assets/styles/layout/searchFilter.styled';
import FilterBy from '../../../components/common/FilterBy';
import { SearchBar } from '../../../components/common/SearchBar';
import { CustomPagination, TableCustom } from '../../../components/common';
import useDebounce from '../../../hooks/useDebounce';
import {
  EditIconButton,
  DeleteIconButton,
  ViewIconButton,
} from '../../../components/common/button/CustomIconButton';
import Create from './Create';
import ModalCustom from '../../../components/common/Modal';
import { useQuery } from '../../../hooks/UseQuery';
import useConfirm from '../../../components/common/useConfirm';
import { IData } from './helpers/interfaces';
import ViewFile from './components/ViewFile';
import formatDate from '../../../components/common/formatDate';
import TableScroll from '../../../components/ui/renderTable/TableScroll';

const tableHeaderObj = [
  [
    {
      text: 'S.NO.',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'Date of QPR',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'Part Name/NO.',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'supplier',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'Information Mode',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'Date & Time of information',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'Information person',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'Complaint QTY',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'Defect',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'First Response time',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'Response time',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'Observation of Gamba',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'Part reject in nos.',
      rowspan: 1,
      colspan: 2,
      style: {
        minWidth: '300px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'Root Couse',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'Counter Measure',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'Responsibility',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'Target Date',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'Impl. Date',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'Effectivness',
      rowspan: 1,
      colspan: 11,
      style: {
        minWidth: '1650px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'HD',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '450px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'DEFECT PHOTO',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'SUPPORTING DOCUMENTS',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'ACTION',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
  ],
];
const tableHeaderOneObj = [
  [
    {
      text: '',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: '',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: '',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: '',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: '',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: '',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: '',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: '',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: '',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: '',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: '',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: '',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'supplier end FG & ASSY LINE',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'TCS end FG & ASSY LINE',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: '',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: '',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: '',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: '',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: '',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: '',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'Lot - 1',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'Lot - 2',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'Lot - 3',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'Lot - 4',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'Lot - 5',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'Lot - 6',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'Lot - 7',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'Lot - 8',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'Lot - 9',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'Lot - 10',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: 'HD EVIDENCE PART NO',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '450px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: '',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: '',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
    {
      text: '',
      rowspan: 1,
      colspan: 1,
      style: {
        minWidth: '150px',
        borderRight: '1px solid black',
        background: '#e6fcf5',
      },
    },
  ],
];

const List = () => {
  const [data, setData] = useState<IData[]>([]);
  const [isModal, setIsModal] = useState<boolean>(false);
  const [render, setRender] = useState(false);
  const [complaintId, setComplaintId] = useState<string | null>(null);
  const [perPage, setPerPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState(0);
  const [id, setId] = useState<string | null>(null);
  const [isFileOpenPopup, setIsFileOpenPopup] = useState(false);
  const [contentType, setContentType] = useState('');
  const [filterCustomer, setFilterCustomer] = useState<any>([]);
  const search = useQuery('search') || '';
  const filter = useQuery('filter') || 'createdAt';
  const page = useQuery('page') || 1;
  const customer = useQuery('customer');
  const defect = useQuery('defects');
  const [all, setAll] = useState(false);

  const [DialogDelete, confirmDelete] = useConfirm(
    'DELETE',
    'Are you sure you want to delete this?'
  );

  useEffect(() => {
    axios
      .get('/api/vendorRoute/vendor/forAutoComplete')
      .then((res) => {
        if (res?.data) {
          const formattedData = res.data.map((customer: any) => ({
            name: customer.vender_name,
            value: customer.vender_name,
          }));
          setFilterCustomer([...formattedData]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const fetchData = async () => {
    const res = await axios
      .get(
        `/api/supplierComplaintRoutes/?page=${page}&sortBy=${filter}&search=${search}&perPage=${perPage}&customer=${customer}&defects=${defect}&all=${all}`
      )
      .catch((err) => {
        console.log(err);
      });

    setData(res?.data?.results);
    setPerPage(res?.data?.perPage);
    setTotalPages(res?.data?.pages);
  };

  const deleteCustomerConcern = async (id: string) => {
    const ans = await confirmDelete();
    if (!ans) return;
    await axios
      .delete(`/api/supplierComplaintRoutes/${id}`)
      .then((res) => {
        alert('Document deleted successfully');
        setRender((prev) => !prev);
      })
      .catch((err) => console.log(err));
  };

  useDebounce(fetchData, 500, [
    page,
    search,
    render,
    isModal,
    filter,
    customer,
    defect,
    all,
  ]);
  return (
    <>
      <ChildHeader text="SUPPLIER COMPLAINT REGISTER">
        <AddButton
          onClick={() => {
            setAll((value) => !value);
          }}
          label={all ? 'Hide' : 'Save'}
        />
        <AddButton
          onClick={() => setIsModal(true)}
          label="NEW SUPPLIER COMPLAINT"
        />
      </ChildHeader>
      <SearchFilterContainer filter={true}>
        <SearchBar label="Search By Defects" />
        <FilterBy
          name="customer"
          label="Filter By Supplier"
          options={filterCustomer}
        />
      </SearchFilterContainer>

      <TableScroll>
        <TableCustom tableHeaderObj={tableHeaderObj}></TableCustom>
        <TableCustom tableHeaderObj={tableHeaderOneObj}>
          <TableBody>
            {data &&
              data.map((item: IData, index: number) => (
                <React.Fragment key={item._id}>
                  <TableRow>
                    <TableCell align="center">
                      {perPage * (+page - 1) + index + 1}
                    </TableCell>
                    <TableCell align="center" style={{ background: '#f1f3f5' }}>
                      {item.qpr_date && formatDate(item.qpr_date)}
                    </TableCell>
                    <TableCell align="center">
                      {item.part_id?.part_name}
                      <br></br>
                      {item.part_id?.part_number}
                    </TableCell>
                    <TableCell align="center" style={{ background: '#f1f3f5' }}>
                      {item.vendor_id?.vender_name}
                    </TableCell>
                    <TableCell align="center">
                      {item?.information_mode}
                    </TableCell>
                    <TableCell align="center" style={{ background: '#f1f3f5' }}>
                      {item.information_date &&
                        formatDate(item.information_date)}
                      <br></br>
                      {item.information_time &&
                        convToTime(item.information_time)}
                    </TableCell>
                    <TableCell align="center">
                      {item?.information_person}
                    </TableCell>
                    <TableCell align="center" style={{ background: '#f1f3f5' }}>
                      {item?.complaint_qty}
                    </TableCell>
                    <TableCell align="center">{item?.defects}</TableCell>
                    <TableCell align="center" style={{ background: '#f1f3f5' }}>
                      {item?.first_response_time}
                    </TableCell>
                    <TableCell align="center">{item?.response_time}</TableCell>
                    <TableCell align="center" style={{ background: '#f1f3f5' }}>
                      {item?.observation_of_gamba}
                    </TableCell>
                    <TableCell align="center">
                      {'Total- ' +
                        (item?.supplier_end_ok_qty + item?.supplier_end_ng_qty)}
                      <br></br>
                      {'OK- ' + item?.supplier_end_ok_qty}
                      <br></br>
                      {'NG- ' + item?.supplier_end_ng_qty}
                    </TableCell>
                    <TableCell align="center" style={{ background: '#f1f3f5' }}>
                      {'Total- ' +
                        (item?.tcs_end_ok_qty + item?.tcs_end_ng_qty)}
                      <br></br>
                      {'OK- ' + item?.tcs_end_ok_qty}
                      <br></br>
                      {'NG- ' + item?.tcs_end_ng_qty}
                    </TableCell>

                    <TableCell align="center">{item?.root_cause}</TableCell>
                    <TableCell align="center" style={{ background: '#f1f3f5' }}>
                      {item?.counter_measure_one}
                      <hr></hr>
                      {item?.counter_measure_two}
                      <hr></hr>
                      {item?.counter_measure_three}
                    </TableCell>

                    <TableCell align="center">{item?.responsibility}</TableCell>
                    <TableCell align="center" style={{ background: '#f1f3f5' }}>
                      {item.target_date && formatDate(item.target_date)}
                    </TableCell>
                    <TableCell align="center">
                      {item.implement_date && formatDate(item.implement_date)}
                    </TableCell>
                    <TableCell align="center" style={{ background: '#da77f2' }}>
                      <b>Date</b>
                      <hr></hr>
                      <b>INVOICE NO.</b>
                      <hr></hr>
                      <b>QTY.</b>
                      <hr></hr>
                      <b>STATUS</b>
                    </TableCell>

                    {item?.effectivness?.map((effect: any, index: any) => {
                      return (
                        <TableCell
                          align="center"
                          style={
                            index % 2 !== 0
                              ? { background: '#f3d9fa' }
                              : { background: 'white' }
                          }
                        >
                          {effect?.date && formatDate(effect.date)}
                          <hr></hr>
                          {effect?.invoice_no}
                          <hr></hr>
                          {effect?.qty}
                          <hr></hr>
                          <span
                            style={
                              effect?.status === 'OK'
                                ? { background: 'green' }
                                : { background: 'red' }
                            }
                          >
                            {effect?.status}
                          </span>
                        </TableCell>
                      );
                    })}
                    <TableCell align="center" style={{ background: '#ffd8a8' }}>
                      <TableCell
                        align="center"
                        style={{
                          width: '150px',
                          borderRight: '1px solid black',
                        }}
                      >
                        {item?.hd_evidence_part_no_one}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{
                          width: '150px',
                          borderRight: '1px solid black',
                        }}
                      >
                        {item?.hd_evidence_part_no_two}
                      </TableCell>
                      <TableCell align="center" style={{ width: '150px' }}>
                        {item?.hd_evidence_part_no_three}
                      </TableCell>
                      <hr></hr>
                      <TableCell align="center">{item?.hd_evidence}</TableCell>
                    </TableCell>
                    <TableCell align="center">
                      {
                        <ViewIconButton
                          tooltipTitle="view"
                          onClick={() => {
                            setId(item._id || null);
                            setIsFileOpenPopup(true);
                            setContentType('image');
                          }}
                        />
                      }
                    </TableCell>
                    <TableCell align="center">
                      {
                        <ViewIconButton
                          tooltipTitle="view"
                          onClick={() => {
                            setId(item._id || null);
                            setIsFileOpenPopup(true);
                            setContentType('file');
                          }}
                        />
                      }
                    </TableCell>
                    <TableCell>
                      <Stack direction="row" sx={{ justifyContent: 'center' }}>
                        <EditIconButton
                          tooltipTitle="EDIT"
                          onClick={() => {
                            setComplaintId(item?._id || '');
                            setIsModal(true);
                          }}
                        />

                        <DeleteIconButton
                          tooltipTitle="DELETE"
                          onClick={() => {
                            deleteCustomerConcern(item?._id || '');
                          }}
                        />
                      </Stack>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
          </TableBody>
        </TableCustom>
      </TableScroll>
      <CustomPagination totalPage={totalPages} />
      <ModalCustom
        openModal={isModal}
        closeModal={() => {
          setComplaintId(null);
          setIsModal(false);
        }}
        title="SUPPLIER REJECTION REGISTER"
      >
        <Create id={complaintId} setIsModal={setIsModal} />
      </ModalCustom>
      <ModalCustom
        title="FILE LIST"
        openModal={isFileOpenPopup}
        closeModal={() => {
          setId(null);
          setIsFileOpenPopup(false);
        }}
      >
        <ViewFile id={id} contentType={contentType} />
      </ModalCustom>
      <DialogDelete isSubmitContent={false} />
    </>
  );
};

export default List;
